<template>
  <form className="k-form" id="signupForm" v-on:submit.prevent="onSubmit()">
    <p className="tcenter">고객님의 비밀번호가 성공적으로 재설정 되었습니다.
      <img src="@/assets/img/etners-main/img_finish.png" className="mtb25"/></p>
    <fieldset>
      <input type="submit" value="로그인 하기" className="mid_btn orange login_btn">
    </fieldset>
  </form>
</template>

<script>
export default {
  name: 'FindPasswordComplete',
  data () {
    return {
      userId: null,
      userPwd: null,
      solCd: null
    }
  },
  props: [
    'method'
  ],
  methods: {
    onSubmit () {
      this.$router.push({ name: 'Login' })
    }
  }
}

</script>
